import api from '../..'

export const getRichTextBlock = (blockId: number) => {
  return api.get(`block_rich_text/block_instances/${blockId}`).then(
    ({
      data: {
        data: { attributes },
      },
    }) => {
      const {
        id,
        blockInstanceableId,
        content,
        blockInstanceable: { name, mandatory, order, description, blockInstanceableType },
      } = attributes
      return { id, blockInstanceableId, content, name, mandatory, order, description, type: blockInstanceableType }
    }
  )
}
